import FormattedMessage from 'I18n/components/FormattedMessage';
import { AgentIconWithFallback } from 'ai-components-ui-library/components/icons/AgentIconWithFallback';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { useState } from 'react';
import styled from 'styled-components';
import { useLazyImage } from '../LazyImageProvider';
import { ListingActionMenu } from '../ListingActionMenu';
import { PolymorphicLink } from '../PolymorphicLink';
import { translateProductType } from '../utils/translateProductType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledActionMenuWrapper = styled.div.withConfig({
  displayName: "EcosystemCardSmall__StyledActionMenuWrapper"
})(["margin-inline-start:auto;opacity:", ";:focus-within{opacity:1;}"], ({
  isHovered
}) => isHovered ? 1 : 0);
export function EcosystemCardSmall({
  name,
  productDisplayTagLabel,
  productType,
  bordered = false,
  compact = false,
  companyName,
  imageSrc,
  installed = false,
  linkMode = 'default',
  listingHref,
  onClick,
  ribbonText,
  ribbonUse,
  rightSlot,
  rightSlotVisible = 'always',
  use = 'default',
  actions = [],
  onActionClick = () => {},
  providerName
}) {
  const imageLoadingMode = useLazyImage();
  const [isHovered, setIsHovered] = useState(false);
  const content = /*#__PURE__*/_jsxs(Flex
  // this is set to "ecosystem-app-card" to make for easy migration off our legacy components
  , {
    "data-test-id": "ecosystem-app-card",
    inlineSize: "100%",
    onClick: onClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    position: "relative",
    children: [/*#__PURE__*/_jsx(PolymorphicLink, {
      href: listingHref,
      linkMode: linkMode,
      marginInlineEnd: "auto",
      use: "unstyled",
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        alignItems: installed ? undefined : 'center',
        children: [/*#__PURE__*/_jsx("div", {
          "aria-hidden": true,
          children: /*#__PURE__*/_jsx(AgentIconWithFallback, {
            iconUrl: imageSrc,
            loading: imageLoadingMode,
            marginBlockEnd: "0",
            name: name,
            size: compact ? 32 : 48
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: compact ? 'h6' : 'h5',
            use: use,
            children: name
          }), /*#__PURE__*/_jsx(Text, {
            as: "small",
            marginBlockStart: compact ? '0' : '50',
            use: use === 'default' ? 'help' : 'on-dark',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "trellisEcosystem.listingStub.subtitle",
              options: {
                productType: productDisplayTagLabel || translateProductType(productType || 'APP'),
                providerName: companyName !== null && companyName !== void 0 ? companyName : providerName
              }
            })
          }), installed && /*#__PURE__*/_jsx(StatusTag, {
            marginBlockStart: compact ? '50' : '100',
            use: "success",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "trellisEcosystem.listingStub.installed"
            })
          })]
        })]
      })
    }), (rightSlotVisible === 'always' || rightSlotVisible === 'hover' && isHovered) && rightSlot, actions.length > 0 &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledActionMenuWrapper, {
      isHovered: isHovered,
      children: /*#__PURE__*/_jsx(ListingActionMenu, {
        actions: actions,
        onActionClick: onActionClick
      })
    })]
  });
  return bordered || ribbonText ? /*#__PURE__*/_jsxs(CardWrapper, {
    compact: true,
    inlineSize: "100%",
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    position: "relative",
    children: [ribbonText && /*#__PURE__*/_jsx(Ribbon, {
      use: ribbonUse,
      position: "right",
      children: ribbonText
    }), /*#__PURE__*/_jsx(CardSection, {
      children: content
    })]
  }) : content;
}